<template>
  <th scope="col" class="px-6 py-3 text-left text-sm font-bold uppercase tracking-wider">
    <slot />
  </th>
</template>
